export default __webpack_public_path__ + "media/images/testimonials/testimonial-dog-body-1de99c877c5e7fa01f685ec439af37ef.png";